export const saveFile = (blob, filename, contentType) => {
  if (!blob) return;

  if (!(blob instanceof Blob)) {
    blob = Array.isArray(blob) ? blob : [blob];
    blob = new Blob(blob, { contentType });
  }

  const blobURL = window.URL.createObjectURL(blob);
  const tempLink = document.createElement('a');
  tempLink.style.display = 'none';
  tempLink.href = blobURL;
  tempLink.setAttribute('download', filename);

  if (typeof tempLink.download === 'undefined') {
    tempLink.setAttribute('target', '_blank');
  }

  document.body.appendChild(tempLink);
  tempLink.click();

  setTimeout(() => {
      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(blobURL);
  }, 200);
};

// export const saveMultiple = async (files, archiveFilename) => {
//   import JsZip from 'jszip';
//   const archive = JsZip();
//   files.forEach(({ blob, filename }) => {
//     archive.file(filename, blob);
//   });

//   const archiveBlob = await archive.generateAsync({ type: 'blob' });
//   saveFile(archiveBlob, archiveFilename);
// };
